import { Box, Button, Drawer, List, ListItemButton, ListItemText, Paper, TextField, Typography } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { SERVER_URI } from "../utils/config"
import { ContactRequests } from "./ContactRequest/ContactRequests"
import { Feedbacks } from "./Feedbacks/Feedbacks"

export const Configurations = () => {
	const [configs, setConfigs] = useState([])
	const [isLoaded, setIsLoaded] = useState(false)
	const [isDrawerOpen, setIsDrawerOpen] = useState(false)

	const CONFIG_TYPES = [
		{ name: "infotext", type: "textarea", title: "Etusivun tiedot" },
		{ name: "feedbackMessage", type: "textarea", title: "Palautteen oletusviesti" },
		{ name: "termsandconditions", type: "textarea", title: "Käyttöehdot" },
		{ name: "email", type: "input", title: "Palautesähköposti" },
		{ name: "orderconfirmationemail", type: "textarea", title: "Tilausvahvistuksen oletusviesti" },
	]

	useEffect(() => {
		const getConfigs = async () => {
			try {
				const response = await axios.get(`${SERVER_URI}/get_configs`)
				setConfigs(response.data.configs)
			} catch (error) {
				console.error(error)
			}
			setIsLoaded(true)
		}
		getConfigs()
	}, [])

	useEffect(() => {
		const handleMouseMove = (event) => {
			if (event.clientX < 50) {
				setIsDrawerOpen(true)
			} else if (event.clientX > 250) {
				setIsDrawerOpen(false)
			}
		}
		window.addEventListener("mousemove", handleMouseMove)

		return () => {
			window.removeEventListener("mousemove", handleMouseMove)
		}
	}, [])

	const handleScrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" })
	}

	const checkExistingConfig = (name) => {
		const config = configs.find((config) => config.name === name)
		if (config) {
			return config
		}
		return {}
	}

	if (!isLoaded) {
		return (
			<Box
				sx={{
					m: 2,
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
				}}>
				<Typography>Ladataan sisältöä...</Typography>
			</Box>
		)
	}

	return (
		<>
			<Drawer anchor="left" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
				<Box
					sx={{ width: 250 }}
					role="presentation"
					onClick={() => setIsDrawerOpen(false)}
					onKeyDown={() => setIsDrawerOpen(false)}>
					<List>
						<ListItemButton onClick={() => handleScrollToTop()}>
							<ListItemText primary="Sivun alkuun" />
						</ListItemButton>
						{CONFIG_TYPES.map((config) => {
							return (
								<ListItemButton key={config.name} component="a" href={`#${config.name}`}>
									<ListItemText primary={config.title} />
								</ListItemButton>
							)
						})}
						<ListItemButton component="a" href="#asiakasviestit">
							<ListItemText primary="Asiakasviestit" />
						</ListItemButton>
						<ListItemButton component="a" href="#yhteydenottopyynnöt">
							<ListItemText primary="Yhteydenottopyynnöt" />
						</ListItemButton>
					</List>
				</Box>
			</Drawer>

			<Box
				sx={{
					p: 2,
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					ml: { sm: "20px" },
				}}>
				<Typography sx={{ mb: 2 }} variant="h2">
					Asetukset
				</Typography>
				<Box sx={{ gap: 4, display: "flex", flexDirection: "column" }}>
					{CONFIG_TYPES.map((config) => (
						<SingleConfiguration
							key={config.name}
							data={{ ...checkExistingConfig(config.name), name: config.name, type: config.type, title: config.title }}
						/>
					))}
				</Box>
				<Typography variant="h4" id="asiakasviestit" mt={4}>
					Asiakasviestit:
				</Typography>
				<Feedbacks />
				<Typography variant="h4" id="yhteydenottopyynnöt" mt={4}>
					Yhteydenottopyynnöt:
				</Typography>
				<ContactRequests />
			</Box>
		</>
	)
}

const SingleConfiguration = ({ data }) => {
	const [config, setConfig] = useState(data)

	const handleConfigChange = (e) => {
		setConfig({ ...config, value: e.target.value })
	}

	const handleConfigSave = async () => {
		try {
			const response = await axios({
				method: config.id ? "put" : "post",
				url: config.id ? `${SERVER_URI}/api/update_config` : `${SERVER_URI}/api/create_config`,
				data: {
					id: config.id,
					name: config.name,
					value: config.value,
				},
			})
			if (!config.id) {
				setConfig({ ...config, id: response.data.id })
			}
		} catch (err) {
			console.error(err)
		}
	}

	return (
		<Paper elevation={4} sx={{ p: 2 }} id={config.name}>
			<Typography variant="h5">{config.title}</Typography>
			<TextField
				variant={data.type === "textarea" ? "outlined" : "standard"}
				fullWidth
				value={config.value}
				onChange={handleConfigChange}
				multiline={data.type === "textarea" ? true : false}
				minRows={data.type === "textarea" ? 4 : 1}
				maxRows={data.type === "textarea" ? 10 : 1}
				sx={{ mt: 1 }}
			/>
			<Button variant="contained" fullWidth onClick={handleConfigSave} sx={{ mt: 2 }}>
				Tallenna
			</Button>
		</Paper>
	)
}
